import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/open-zi.svg';
const _withScopeId = n => (_pushScopeId("data-v-6196a1f1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mt-2 mb-2"
};
const _hoisted_2 = {
  class: "row",
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_3 = {
  class: "col-12"
};
const _hoisted_4 = {
  class: "dashboard-card border-radius-20 pl-4 pr-4 pt-3 pb-5"
};
const _hoisted_5 = {
  class: "w-100 mb-3 mt-2 d-flex justify-content-between"
};
const _hoisted_6 = {
  class: "fw-extra-bold overview-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4"
}, null, -1));
const _hoisted_8 = {
  class: "info-panel"
};
const _hoisted_9 = {
  class: "info-group"
};
const _hoisted_10 = {
  class: "info-item"
};
const _hoisted_11 = {
  class: "info-item-title"
};
const _hoisted_12 = {
  class: "info-item-value"
};
const _hoisted_13 = {
  class: "fw-bold fsi-24"
};
const _hoisted_14 = {
  class: "info-item"
};
const _hoisted_15 = {
  class: "info-item-title"
};
const _hoisted_16 = {
  class: "info-item-value"
};
const _hoisted_17 = {
  class: "fw-bold fsi-24"
};
const _hoisted_18 = {
  class: "info-item"
};
const _hoisted_19 = {
  class: "info-item-title"
};
const _hoisted_20 = {
  class: "info-item-value"
};
const _hoisted_21 = {
  class: "fw-bold fsi-24"
};
const _hoisted_22 = {
  class: "info-item"
};
const _hoisted_23 = {
  class: "info-item-title"
};
const _hoisted_24 = {
  class: "info-item-value"
};
const _hoisted_25 = {
  class: "fw-bold fsi-24"
};
const _hoisted_26 = {
  class: "info-item"
};
const _hoisted_27 = {
  class: "info-item-title"
};
const _hoisted_28 = {
  class: "info-item-value"
};
const _hoisted_29 = {
  class: "fw-bold fsi-24"
};
const _hoisted_30 = {
  class: "info-item"
};
const _hoisted_31 = {
  class: "info-item-title"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-item-value"
}, "--%", -1));
const _hoisted_33 = {
  class: "info-group"
};
const _hoisted_34 = {
  class: "info-item"
};
const _hoisted_35 = {
  class: "info-item-title"
};
const _hoisted_36 = {
  class: "info-item-value"
};
const _hoisted_37 = {
  class: "fw-bold fsi-24"
};
const _hoisted_38 = {
  class: "info-item"
};
const _hoisted_39 = {
  class: "info-item-title"
};
const _hoisted_40 = {
  class: "info-item-value"
};
const _hoisted_41 = {
  class: "fw-bold fsi-24"
};
const _hoisted_42 = {
  class: "info-item"
};
const _hoisted_43 = {
  class: "info-item-title"
};
const _hoisted_44 = {
  class: "info-item-value"
};
const _hoisted_45 = {
  class: "fw-bold fsi-24"
};
const _hoisted_46 = {
  class: "info-item"
};
const _hoisted_47 = {
  class: "info-item-title"
};
const _hoisted_48 = {
  class: "info-item-value fs-12"
};
const _hoisted_49 = {
  class: "fw-bold fsi-24"
};
const _hoisted_50 = {
  class: "d-flex w-100"
};
const _hoisted_51 = {
  style: {
    "white-space": "nowrap"
  },
  class: "mr-3 mr-sm-4"
};
const _hoisted_52 = {
  class: "info-item-value-sector"
};
const _hoisted_53 = {
  class: "info-item-value-sector text-right w-100",
  style: {
    "color": "rgba(217,50,50,0.9)"
  }
};
const _hoisted_54 = {
  style: {
    "white-space": "nowrap"
  }
};
const _hoisted_55 = {
  class: "info-item-value-sector",
  style: {
    "color": "rgba(56,158,71,0.9)"
  }
};
const _hoisted_56 = {
  class: "info-item-value-sector text-right w-100",
  style: {
    "color": "rgba(217,195,50,0.9)"
  }
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4"
}, null, -1));
const _hoisted_58 = {
  class: "info-panel"
};
const _hoisted_59 = {
  class: "fw-extra-bold fsi-16 mb-4"
};
const _hoisted_60 = {
  class: "w-100"
};
const _hoisted_61 = {
  class: "node-item"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "node-item-title"
}, "Owner", -1));
const _hoisted_63 = {
  class: "node-item-value"
};
const _hoisted_64 = {
  class: "fw-bold fsi-24"
};
const _hoisted_65 = {
  class: "node-item"
};
const _hoisted_66 = {
  class: "node-item-title"
};
const _hoisted_67 = {
  class: "node-item-value"
};
const _hoisted_68 = {
  class: "fw-bold fsi-24"
};
const _hoisted_69 = {
  key: 0,
  class: "d-none d-sm-block"
};
const _hoisted_70 = {
  key: 1,
  class: "d-block d-sm-none"
};
const _hoisted_71 = ["href"];
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "18px",
    "margin-bottom": "2px",
    "margin-left": "2px"
  },
  src: _imports_0,
  alt: ""
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('farm.console.Miner Overview')), 1)]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('farm.minerOverview.Address Balance')), 1), _createElementVNode("div", _hoisted_12, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatWalletFilPrice(_ctx.positionValue)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('farm.minerOverview.Available Balance')), 1), _createElementVNode("div", _hoisted_16, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatWalletFilPrice(_ctx.availableBalance)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('farm.minerOverview.Initial Pledge')), 1), _createElementVNode("div", _hoisted_20, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatWalletFilPrice(_ctx.pledge)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('farm.minerOverview.Locked Rewards')), 1), _createElementVNode("div", _hoisted_24, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatWalletFilPrice(_ctx.lockedRewards)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('farm.minerOverview.Average pledge')), 1), _createElementVNode("div", _hoisted_28, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatWalletFilPrice(_ctx.averagePledge)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('farm.minerOverview.Sector Liquidation Percentage')), 1), _hoisted_32])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('farm.minerOverview.Adjusted Power')) + " ", 1), _createElementVNode("div", _hoisted_36, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatBit(_ctx.qualityAdjPower, 2)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('farm.minerOverview.Raw Byte Power')), 1), _createElementVNode("div", _hoisted_40, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatBit(_ctx.rawBytePower, 2)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('farm.minerOverview.Sector Size')), 1), _createElementVNode("div", _hoisted_44, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($options.formatBit(_ctx.sectorSize, null)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('farm.minerOverview.Sector Status')), 1), _createElementVNode("div", _hoisted_48, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.sectorLive) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.total')), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.sectorFaulty) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.faults')), 1)]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.sectorActive) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.active')), 1), _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.sectorRecoveries) + " " + _toDisplayString(_ctx.$t('farm.minerOverview.recoveries')), 1)])])]),
    _: 1
  }, 8, ["loading"])])])])]), _hoisted_57, _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('farm.minerOverview.Account Overview')), 1), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_hoisted_62, _createElementVNode("div", _hoisted_63, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createTextVNode(" f0" + _toDisplayString(_ctx.owner), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('farm.minerOverview.Contract Operator')), 1), _createElementVNode("div", _hoisted_67, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_68, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_ctx.operator !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.operator), 1)) : _createCommentVNode("", true), _ctx.operator !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString($options.simpleValue(_ctx.operator, 8, 8)), 1)) : _createCommentVNode("", true), _ctx.operator === '' ? (_openBlock(), _createElementBlock("a", {
      key: 2,
      href: `/#/farm/operator/${$props.nodeId}`,
      style: {
        "color": "#6752F0"
      },
      class: "cursor-pointer"
    }, [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.ApproveOperatorBtn')), 1), _hoisted_72], 8, _hoisted_71)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])])])])])])])]);
}